import React from 'react';
import {
  Alert,
  Typography,
  Box,
  Chip
} from '@mui/material';
import {
  Info,
  Warning
} from '@mui/icons-material';

const EncodingInfo = ({ content, fileName }) => {
  // Sprawdź czy tekst zawiera polskie znaki
  const hasPolishChars = /[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/.test(content);

  // Sprawdź czy są znaki zapytania które mogą oznaczać problemy z kodowaniem
  const hasEncodingIssues = content.includes('�') ||
    (content.includes('?') && content.match(/\?{2,}/)); // wielokrotne znaki zapytania

  const detectEncoding = () => {
    // Prosta heurystyka na podstawie obecności polskich znaków
    if (hasPolishChars && !hasEncodingIssues) {
      return 'UTF-8 (wykryto polskie znaki)';
    } else if (hasEncodingIssues) {
      return 'Problemy z kodowaniem';
    } else {
      return 'ASCII/UTF-8';
    }
  };

  const getSeverity = () => {
    if (hasEncodingIssues) return 'warning';
    if (hasPolishChars) return 'success';
    return 'info';
  };

  const encoding = detectEncoding();
  const severity = getSeverity();

  return (
    <Alert
      severity={severity}
      icon={severity === 'warning' ? <Warning /> : <Info />}
      sx={{ mb: 2 }}
    >
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
        <Typography variant="body2">
          <strong>Kodowanie pliku:</strong>
        </Typography>
        <Chip
          label={encoding}
          size="small"
          color={severity === 'warning' ? 'warning' : 'primary'}
          variant="outlined"
        />
      </Box>

      {hasEncodingIssues && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          Wykryto problemy z kodowaniem znaków. Jeśli widzisz znaki zapytania zamiast polskich liter,
          spróbuj przesłać plik ponownie lub skontaktuj się z bankiem w sprawie formatu eksportu.
        </Typography>
      )}

      {hasPolishChars && !hasEncodingIssues && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          ✅ Polskie znaki zostały poprawnie rozpoznane i będą zachowane w pliku wynikowym.
        </Typography>
      )}
    </Alert>
  );
};

export default EncodingInfo;